import { render, staticRenderFns } from "./ConsumerInfo.vue?vue&type=template&id=ec244748&"
import script from "./ConsumerInfo.vue?vue&type=script&lang=js&"
export * from "./ConsumerInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports